var _defs, _line, _path, _circle, _line2, _path2, _circle2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _polygon, _polygon2, _polygon3, _rect, _rect2, _path30, _circle3, _line3, _line4, _path31, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIvm2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 418.96 452.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-6{fill:none;stroke:#6b7b84;stroke-miterlimit:10;stroke-width:0.5px;}.cls-2{fill:#812990;}.cls-3{fill:#231f20;}.cls-4{fill:#6b7b84;}.cls-5{fill:#d5ddeb;}.cls-6{stroke-dasharray:2 2;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.73,
    y1: 348.9,
    x2: 86.93,
    y2: 348.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6,351.68v-4.46l-.85.91-.4-.41,1.33-1.37h.59v5.33Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 5.92,
    cy: 348.9,
    r: 5.67
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.73,
    y1: 192.48,
    x2: 86.93,
    y2: 192.48
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4,195.26v-.54c1.92-1.5,3-2.39,3-3.31a1,1,0,0,0-1.12-1,1.8,1.8,0,0,0-1.45.67l-.4-.43a2.27,2.27,0,0,1,1.85-.83,1.62,1.62,0,0,1,1.79,1.56c0,1.09-1.1,2.08-2.59,3.26H7.66v.59Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 5.92,
    cy: 192.48,
    r: 5.67
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M194.23,332.65h-.93v2.61h-.54v-2.61h-.93v-.54h2.4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M197.61,332.11v3.15h-.54V333l-1,1.61L195,333v2.23h-.54v-3.15H195l1,1.53,1-1.53Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111,340.3v1a7.26,7.26,0,0,0-1.79-1,6.51,6.51,0,0,0-2.33-.38,6.94,6.94,0,0,0-2.72.52,6.63,6.63,0,0,0-2.15,1.43,6.7,6.7,0,0,0-1.93,4.76,6.65,6.65,0,0,0,.51,2.59,6.51,6.51,0,0,0,3.57,3.57,6.94,6.94,0,0,0,2.72.52h.27a7.33,7.33,0,0,0,2.74-.51v-3.6a4,4,0,0,1-1.26.8,4.21,4.21,0,0,1-1.47.26,4.44,4.44,0,0,1-.63,0h0a5.17,5.17,0,0,1-.86-.22,3.53,3.53,0,0,1-1.24-.8,3.51,3.51,0,0,1,0-5.16,3.65,3.65,0,0,1,1.24-.79,4,4,0,0,1,1.49-.28,3.79,3.79,0,0,1,2.73,1.07,3.42,3.42,0,0,1,1.12,2.59v6.68h3.22V340.3Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M97.4,353.36l-7.12-6.86v6.86H87.06v-18.1h3.22v6.85l7.12-6.82H102l-9.4,9,9.4,9.06Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.56,340a5.75,5.75,0,0,1,2.38.47,5.42,5.42,0,0,1,1.83,1.29,6.1,6.1,0,0,1,1.18,1.92,6.48,6.48,0,0,1,.42,2.34v7.37h-3.22V346a2.72,2.72,0,0,0-.93-2.11,3.27,3.27,0,0,0-4.42,0,2.79,2.79,0,0,0-.91,2.11v7.37h-3.21v-13h3.21v1a6.28,6.28,0,0,1,1.63-1A5.33,5.33,0,0,1,122.56,340Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M166.09,340.32a5.9,5.9,0,0,1,2.16-.38V343a3.83,3.83,0,0,0-2.73,1.07,3.56,3.56,0,0,0-1.13,2.59v6.71h-3.21V340.3h3.21v1A7.23,7.23,0,0,1,166.09,340.32Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M175.52,340a7.16,7.16,0,0,1,2.75.52,7.08,7.08,0,0,1,2.25,1.43,6.82,6.82,0,0,1,1.51,2.14,6.25,6.25,0,0,1,.55,2.62,6.18,6.18,0,0,1-.55,2.59,6.6,6.6,0,0,1-1.51,2.14,6.91,6.91,0,0,1-2.25,1.43,7.56,7.56,0,0,1-5.51,0,6.91,6.91,0,0,1-2.25-1.43,6.6,6.6,0,0,1-1.51-2.14,6.18,6.18,0,0,1-.55-2.59,6.25,6.25,0,0,1,.55-2.62,6.82,6.82,0,0,1,1.51-2.14,7.08,7.08,0,0,1,2.25-1.43A7.21,7.21,0,0,1,175.52,340Zm0,3a3.79,3.79,0,0,0-2.73,1.07,3.51,3.51,0,0,0,0,5.16,3.53,3.53,0,0,0,1.24.8,4.36,4.36,0,0,0,1.49.26,4.29,4.29,0,0,0,1.47-.26,4,4,0,0,0,1.26-.8,3.53,3.53,0,0,0,0-5.16A3.92,3.92,0,0,0,175.52,343Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M190.55,340a7.16,7.16,0,0,1,2.75.52,7.08,7.08,0,0,1,2.25,1.43,6.82,6.82,0,0,1,1.51,2.14,6.25,6.25,0,0,1,.55,2.62,6.18,6.18,0,0,1-.55,2.59,6.6,6.6,0,0,1-1.51,2.14,6.91,6.91,0,0,1-2.25,1.43,7.56,7.56,0,0,1-5.51,0,6.91,6.91,0,0,1-2.25-1.43,6.6,6.6,0,0,1-1.51-2.14,6.18,6.18,0,0,1-.55-2.59,6.25,6.25,0,0,1,.55-2.62,6.82,6.82,0,0,1,1.51-2.14,7.08,7.08,0,0,1,2.25-1.43A7.21,7.21,0,0,1,190.55,340Zm0,3a3.79,3.79,0,0,0-2.73,1.07,3.51,3.51,0,0,0,0,5.16,3.53,3.53,0,0,0,1.24.8,4.36,4.36,0,0,0,1.49.26,4.29,4.29,0,0,0,1.47-.26,4,4,0,0,0,1.26-.8,3.53,3.53,0,0,0,0-5.16A3.92,3.92,0,0,0,190.55,343Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M156.19,340.3v1a7.08,7.08,0,0,0-1.79-1,6.47,6.47,0,0,0-2.33-.38,6.94,6.94,0,0,0-2.72.52,6.63,6.63,0,0,0-4.08,6.19,6.65,6.65,0,0,0,.51,2.59,6.51,6.51,0,0,0,1.42,2.14,6.58,6.58,0,0,0,2.15,1.43,6.94,6.94,0,0,0,2.72.52h.27a7.33,7.33,0,0,0,2.74-.51v-3.6a3.91,3.91,0,0,1-1.26.8,4.43,4.43,0,0,1-2.09.22h0a5,5,0,0,1-.87-.22,3.62,3.62,0,0,1-1.24-.8,3.53,3.53,0,0,1,0-5.16,3.75,3.75,0,0,1,1.24-.79,4,4,0,0,1,1.49-.28,3.79,3.79,0,0,1,2.73,1.07,3.42,3.42,0,0,1,1.12,2.59v6.68h3.22V340.3Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M140.63,340.3v1a7.33,7.33,0,0,0-1.8-1,6,6,0,0,0-1.16-.3,8.58,8.58,0,0,0-1.38-.11,6.78,6.78,0,0,0-2.66.52,6.19,6.19,0,0,0-2.09,1.44,6.55,6.55,0,0,0-1.35,2.13,6.94,6.94,0,0,0-.49,2.62v0h0a6.65,6.65,0,0,0,.51,2.59,6.49,6.49,0,0,0,3.58,3.57,6.89,6.89,0,0,0,2.71.52H137a7.37,7.37,0,0,0,2.54-.51v-3.6a3.8,3.8,0,0,1-1.26.8,4.43,4.43,0,0,1-2.09.22h0a5,5,0,0,1-.87-.22,3.62,3.62,0,0,1-1.24-.8,3.42,3.42,0,0,1-1.12-2.58,3.49,3.49,0,0,1,.26-1.35.54.54,0,0,1,0-.11,3.44,3.44,0,0,1,.81-1.12,3.75,3.75,0,0,1,1.24-.79,4,4,0,0,1,1.49-.28,3.79,3.79,0,0,1,2.73,1.07,3.44,3.44,0,0,1,.81,1.12.54.54,0,0,1,.05.11,3.37,3.37,0,0,1,.27,1.36v5.08a3.42,3.42,0,0,1-1.13,2.57,3.7,3.7,0,0,1-2.73,1.09,3.8,3.8,0,0,1-1.93-.5l-2.33,2.18a7.35,7.35,0,0,0,2,1,7.49,7.49,0,0,0,5-.18,7.56,7.56,0,0,0,2.25-1.45,6.83,6.83,0,0,0,1.51-2.13,6.38,6.38,0,0,0,.55-2.6V340.3Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M90.79,364.42v.85H87.06v-4.86h3.59v.85H88v1.24h2.2v.83H88v1.09Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M97,360v5.2H96V365a2.19,2.19,0,0,1-1.09.29,1.94,1.94,0,0,1,0-3.88,2.19,2.19,0,0,1,1.09.29V360Zm-1,4.07v-1.51a1.44,1.44,0,0,0-.92-.31A1.07,1.07,0,0,0,94,363.33a1.05,1.05,0,0,0,1.12,1.07A1.41,1.41,0,0,0,96,364.08Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M103.08,361.47v3.75h-1V365a1.8,1.8,0,0,1-1,.3c-1.1,0-1.6-.51-1.6-1.72v-2.08h1v2.08c0,.58.28.86.81.86a1.26,1.26,0,0,0,.85-.3v-2.64Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M109,364.52a1.81,1.81,0,0,1-1.45.75,1.94,1.94,0,1,1,0-3.87,1.8,1.8,0,0,1,1.46.75l-.62.57a1,1,0,0,0-.84-.46,1.08,1.08,0,1,0,0,2.15,1,1,0,0,0,.84-.46Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M115.13,361.47v3.75h-1v-.28a1.92,1.92,0,0,1-1.09.33,1.94,1.94,0,0,1,0-3.88,2.23,2.23,0,0,1,1.09.31v-.23Zm-1,1.12a1.41,1.41,0,0,0-.92-.33,1.08,1.08,0,1,0,0,2.15,1.39,1.39,0,0,0,.92-.32Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M118.89,362.26v1.33c0,.67.11.86.6.86.16,0,.31,0,.44,0v.71a2.18,2.18,0,0,1-.87.14,1.07,1.07,0,0,1-1.13-1.18v-1.83h-.53v-.79h.53V360h1v1.46h1v.79Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M122.23,360.56a.57.57,0,0,1,.55-.57.56.56,0,0,1,.55.57.55.55,0,0,1-.55.56A.56.56,0,0,1,122.23,360.56Zm.08,1h1v3.74h-1Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M129.79,363.34a2,2,0,1,1-2-1.94A2,2,0,0,1,129.79,363.34Zm-.94,0a1.11,1.11,0,1,0-1.11,1.07A1.1,1.1,0,0,0,128.85,363.34Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M135.77,363.18v2.09h-1v-2.09c0-.58-.28-.86-.82-.86a1.2,1.2,0,0,0-.82.3v2.65h-1v-3.74h1v.23a1.74,1.74,0,0,1,1-.3C135.26,361.46,135.77,362,135.77,363.18Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M143.29,361.26V363h2.33v.86h-2.33v1.42h-1v-4.86H146v.85Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M152.19,363.34a2,2,0,1,1-2.05-1.94A2,2,0,0,1,152.19,363.34Zm-.94,0a1.11,1.11,0,1,0-1.11,1.07A1.1,1.1,0,0,0,151.25,363.34Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M158.15,361.47v3.75h-1V365a1.85,1.85,0,0,1-1,.3c-1.1,0-1.6-.51-1.6-1.72v-2.08h1v2.08c0,.58.28.86.81.86a1.28,1.28,0,0,0,.85-.3v-2.64Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M164.3,363.18v2.09h-1v-2.09c0-.58-.28-.86-.81-.86a1.2,1.2,0,0,0-.83.3v2.65h-1v-3.74h1v.23a1.76,1.76,0,0,1,1-.3C163.8,361.46,164.3,362,164.3,363.18Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M170.63,360v5.2h-1V365a2.22,2.22,0,0,1-1.09.29,1.94,1.94,0,0,1,0-3.88,2.19,2.19,0,0,1,1.09.29V360Zm-1,4.07v-1.51a1.44,1.44,0,0,0-.92-.31,1.07,1.07,0,0,0-1.12,1.07,1.05,1.05,0,0,0,1.12,1.07A1.41,1.41,0,0,0,169.67,364.08Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M177,361.47v3.75h-1v-.28a1.93,1.93,0,0,1-1.1.33,1.94,1.94,0,0,1,0-3.88,2.27,2.27,0,0,1,1.1.31v-.23Zm-1,1.12a1.41,1.41,0,0,0-.92-.33,1.08,1.08,0,1,0,0,2.15,1.41,1.41,0,0,0,.92-.32Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M180.74,362.26v1.33c0,.67.11.86.59.86.17,0,.31,0,.44,0v.71a2.16,2.16,0,0,1-.86.14,1.08,1.08,0,0,1-1.14-1.18v-1.83h-.53v-.79h.53V360h1v1.46h1v.79Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M184.08,360.56a.55.55,0,1,1,1.1,0,.55.55,0,1,1-1.1,0Zm.07,1h1v3.74h-1Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M191.64,363.34a2.05,2.05,0,1,1-2-1.94A2,2,0,0,1,191.64,363.34Zm-.95,0a1.1,1.1,0,1,0-1.1,1.07A1.09,1.09,0,0,0,190.69,363.34Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M197.61,363.18v2.09h-1v-2.09c0-.58-.28-.86-.81-.86a1.22,1.22,0,0,0-.83.3v2.65h-1v-3.74h1v.23a1.76,1.76,0,0,1,1-.3C197.11,361.46,197.61,362,197.61,363.18Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "418.72 402.12 418.72 402.12 197.61 33.62 418.72 33.62 418.72 402.12"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "418.72 402.12 308.17 217.87 197.61 402.12 418.72 402.12"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "87.06 70.47 197.61 70.47 289.74 217.87 234.46 310 87.06 310 87.06 70.47"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 87.07,
    y: 328.42,
    width: 110.55,
    height: 36.85
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50.2,
    y: 33.62,
    width: 368.5,
    height: 368.5
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M315.48,7.85l.39-.42a1.84,1.84,0,0,0,1.49.7c.77,0,1.25-.39,1.25-1s-.55-.94-1.33-.94h-.55V5.59h.55c.67,0,1.24-.26,1.24-.88s-.55-.91-1.19-.91a1.78,1.78,0,0,0-1.41.65L315.55,4a2.29,2.29,0,0,1,1.83-.82c1,0,1.8.52,1.8,1.41A1.28,1.28,0,0,1,318,5.87a1.36,1.36,0,0,1,1.23,1.32c0,.89-.72,1.54-1.9,1.54A2.25,2.25,0,0,1,315.48,7.85Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 317.48,
    cy: 5.92,
    r: 5.67
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 317.47,
    y1: 51.56,
    x2: 317.47,
    y2: 11.63
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 306.56,
    y1: 440.79,
    x2: 306.56,
    y2: 345.78
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M307.11,449.17v-1.35h-2.54v-.55l2.29-3.43h.91v3.39h.75v.59h-.75v1.35Zm0-4.72-1.87,2.78h1.87Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 306.56,
    cy: 446.46,
    r: 5.67
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIvm2);
export default __webpack_public_path__ + "static/media/ivm2.4e12f74219320b9cb468c343146d820a.svg";
export { ForwardRef as ReactComponent };